import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeFirstLetterEachWord'
})
export class CapitalizeFirstLetterEachWordPipe implements PipeTransform {

  transform(words: any, ...args: unknown[]): unknown {
    if (words) {
      const separateWord = words.toLowerCase().split(' ');
      for (let i = 0; i < separateWord.length; i++) {
        if (separateWord[i].length > 2) {
          separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
            separateWord[i].substring(1);
        }
      }
      return separateWord.join(' ');
    } else {
      return words;
    }
  }

}
